import { NgModule, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'emptyToEnd',
  pure: false
})
export class EmptyToEndPipe implements PipeTransform {
  transform(arr: any[], key: string): any {
    if (!Array.isArray(arr)) {
      return arr;
    }

    const present = arr.filter(item => {
      return splitKey(item, key);
    });

    const empty = arr.filter(item => {
      return !splitKey(item, key);
    });

    return present.concat(empty);

    function splitKey(item: any, itemKey: string) {
      if (itemKey.indexOf('.') > 0) {
        const keys = itemKey.split('.');
        if (item[keys[0]]) {
          return item[keys[0]][keys[1]];
        } else {
          return item[keys[0]];
        }
      } else {
        return item[itemKey];
      }
    }
  }
}

@NgModule({
  imports: [],
  declarations: [EmptyToEndPipe],
  exports: [EmptyToEndPipe]
})
export class EmptyToEndPipeModule { }
